/* Recensioni Creazioni Fadal: "Mostra altre" e visualizzatore foto */
(function () {
  var lb = null, list = [], idx = 0;

  function show(i) {
    idx = (i + list.length) % list.length;
    lb.querySelector('img').src = list[idx];
  }

  function close() {
    if (lb) { lb.remove(); lb = null; document.removeEventListener('keydown', onKey); }
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight' && list.length > 1) show(idx + 1);
    else if (e.key === 'ArrowLeft' && list.length > 1) show(idx - 1);
  }

  function open(urls) {
    list = urls; close();
    lb = document.createElement('div');
    lb.className = 'fr-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML = '<img alt="Foto della recensione"><button type="button" class="fr-x" aria-label="Chiudi">&times;</button>' +
      (list.length > 1 ? '<button type="button" class="fr-prev" aria-label="Foto precedente">&#8249;</button>' +
        '<button type="button" class="fr-next" aria-label="Foto successiva">&#8250;</button>' : '');
    lb.addEventListener('click', function (e) {
      if (e.target.classList.contains('fr-prev')) show(idx - 1);
      else if (e.target.classList.contains('fr-next')) show(idx + 1);
      else if (e.target.tagName !== 'IMG') close();
    });
    document.body.appendChild(lb);
    document.addEventListener('keydown', onKey);
    show(0);
    lb.querySelector('.fr-x').focus();
  }

  document.addEventListener('click', function (e) {
    var more = e.target.closest && e.target.closest('[data-fr-more]');
    if (more) {
      var step = parseInt(more.getAttribute('data-fr-more'), 10) || 12;
      var hidden = more.parentElement.querySelectorAll('.fr-card.fr-hidden');
      for (var i = 0; i < hidden.length && i < step; i++) hidden[i].classList.remove('fr-hidden');
      if (hidden.length <= step) more.remove();
      return;
    }
    var photo = e.target.closest && e.target.closest('.fr-photo');
    if (photo) open(photo.getAttribute('data-fr-imgs').split(','));
  });
})();
